// import React, { useState } from "react";

// const MediaPage = () => {
//   // 🌟 LIGHTBOX STATE
//   const [activeVideo, setActiveVideo] = useState(null);

//   // Extract YouTube thumbnail
//   const getYouTubeThumb = (url) => {
//     try {
//       const id = url.split("youtu.be/")[1] || url.split("v=")[1];
//       return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
//     } catch {
//       return "/assets/default_video_thumb.jpg";
//     }
//   };

//   // Extract Google Drive thumbnail
//   const getDriveThumb = (url) => {
//     const id = url.match(/\/d\/(.*?)\//)?.[1];
//     return `https://drive.google.com/thumbnail?id=${id}`;
//   };

//   const interviews = [
//     { name: "Prof. Adetola Kassim", url: "https://youtu.be/6M-K5-eOZAw" },
//     { name: "Prof. Edamisan Temiye", url: "https://youtu.be/qlmd-MS-KnU" },
//     { name: "Prof. Josu De La Fuente", url: "https://youtu.be/FFJ_sw2EgSA" },
//     {
//       name: "Prof. Titi Adeyemo",
//       url: "https://drive.google.com/file/d/1MwGSsGkTBjH8pJpiQ0PHuy1WPMCcXe4m/view",
//     },
//     { name: "Dr. Kalejaiye", url: "https://youtu.be/h75NEblTGZ8" },
//     {
//       name: "Dr. Ugonna Fakile",
//       url: "https://drive.google.com/file/d/1iiIFLNQAniq0-fEF_oLZtd9Onn74mAFC/view",
//     },
//     { name: "Dr. Adelabu", url: "https://youtu.be/y1jnL2a1WoY" },
//     { name: "Dr. Ann Ogbenne", url: "https://youtu.be/E9UwJdKs2Es" },
//     { name: "Nurse Bamgboye", url: "https://youtu.be/QD2VfllaxO8" },
//     { name: "Pharm Vivian", url: "https://youtu.be/Wm7jN6CiKGs" },
//   ];

//   const extraMedia = [
//     { name: "Dr. Annette", url: "https://youtu.be/CRCR7plW_sw" },
//     { name: "Olin Gary", url: "https://youtu.be/F6JK1zbozrQ" },
//     { name: "Carina Wilkerson", url: "https://youtu.be/PI3rIFAMXlU" },
//     { name: "Eugenia Trigoso", url: "https://youtu.be/rzzJpY6IQwY" },
//   ];

//   const partners = [
//     { name: "Prof. Wasiu Adeyemo (LUTH)", url: "https://youtu.be/M82F5fUYTys" },
//     { name: "Chief Afolabi (Amni)", url: "https://youtu.be/jGiwKQhPyh0" },
//     { name: "Edith Lawson (NNPC)", url: "https://youtu.be/Z03HU3dOwhE" },
//     { name: "NNPC Official Video", url: "https://youtu.be/EeTp8_iSf5k" },
//   ];

//   // Render card
//   const renderCard = (item) => {
//     const isYouTube = item.url.includes("youtu");

//     const thumb = isYouTube
//       ? getYouTubeThumb(item.url)
//       : getDriveThumb(item.url);

//     return (
//       <div
//         onClick={() => setActiveVideo(item.url)}
//         className="group cursor-pointer relative block rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all bg-black"
//       >
//         {/* Image */}
//         <img
//           src={thumb}
//           alt={item.name}
//           className="w-full h-64 object-cover transform group-hover:scale-105 transition-all duration-500 opacity-90"
//         />

//         {/* Gradient Overlay */}
//         <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/40 to-black/70 group-hover:opacity-80 transition-all"></div>

//         {/* Play Button */}
//         <div className="absolute inset-0 flex items-center justify-center">
//           <div className="w-16 h-16 bg-white/90 group-hover:bg-white rounded-full flex items-center justify-center shadow-xl group-hover:scale-125 transition transform">
//             <div className="w-0 h-0 border-t-[10px] border-b-[10px] border-l-[16px] border-transparent border-l-red-600 ml-1"></div>
//           </div>
//         </div>

//         {/* Title */}
//         <p className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-center text-[15px] py-3 font-semibold tracking-wide">
//           {item.name}
//         </p>
//       </div>
//     );
//   };

//   return (
//     <>
//       {/* 🔥 LIGHTBOX VIDEO PLAYER */}
//       {activeVideo && (
//         <div className="fixed inset-0 z-[999] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-fadeIn">
//           <div className="relative w-full max-w-4xl">
//             {/* Close Btn */}
//             <button
//               onClick={() => setActiveVideo(null)}
//               className="absolute -top-10 right-0 text-white bg-red-600 hover:bg-red-700 px-4 py-2 rounded-full shadow-lg transition"
//             >
//               Close
//             </button>

//             <iframe
//               src={activeVideo.replace("youtu.be/", "www.youtube.com/embed/")}
//               className="w-full aspect-video rounded-lg shadow-2xl"
//               allowFullScreen
//             ></iframe>
//           </div>
//         </div>
//       )}

//       {/* PAGE CONTENT */}
//       <div className="px-[25px] sm:px-16 py-24 space-y-20">
//         {/* HEADER */}
//         <div className="text-center">
//           <h1 className="text-5xl font-extrabold text-primary_red tracking-tight">
//             Media Gallery
//           </h1>
//           <p className="text-gray-700 text-lg mt-3 max-w-3xl mx-auto">
//             Explore powerful stories, expert perspectives, and voices shaping
//             the future of Bone Marrow Transplantation and Sickle Cell care.
//           </p>
//         </div>

//         {/* SECTIONS */}
//         <MediaSection
//           title="Expert Interviews"
//           items={interviews}
//           renderCard={renderCard}
//         />
//         <MediaSection
//           title="More Voices & Stories"
//           items={extraMedia}
//           renderCard={renderCard}
//         />
//         <MediaSection
//           title="Our Partners Speak"
//           items={partners}
//           renderCard={renderCard}
//         />
//       </div>
//     </>
//   );
// };

// // SECTION COMPONENT
// const MediaSection = ({ title, items, renderCard }) => (
//   <section>
//     <div className="flex items-center gap-4 mb-6">
//       <h2 className="text-3xl font-bold">{title}</h2>
//       <div className="h-[2px] bg-primary_red w-16"></div>
//     </div>

//     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
//       {items.map((item, idx) => (
//         <div key={idx}>{renderCard(item)}</div>
//       ))}
//     </div>
//   </section>
// );

// export default MediaPage;

// =================================================

import React, { useState, useEffect } from "react";

// -------- DATA --------

const interviews = [
  {
    name: "Prof. Adetola Kassim",
    url: "https://youtu.be/6M-K5-eOZAw",
    type: "interview",
  },
  {
    name: "Prof. Edamisan Temiye",
    url: "https://youtu.be/qlmd-MS-KnU",
    type: "interview",
  },
  {
    name: "Prof. Josu De La Fuente",
    url: "https://youtu.be/FFJ_sw2EgSA",
    type: "interview",
  },
  {
    name: "Prof. Titi Adeyemo",
    url: "https://drive.google.com/file/d/1MwGSsGkTBjH8pJpiQ0PHuy1WPMCcXe4m/view",
    type: "interview",
  },
  {
    name: "Dr. Kalejaiye",
    url: "https://youtu.be/h75NEblTGZ8",
    type: "interview",
  },
  {
    name: "Dr. Ugonna Fakile",
    url: "https://drive.google.com/file/d/1iiIFLNQAniq0-fEF_oLZtd9Onn74mAFC/view",
    type: "interview",
  },
  {
    name: "Dr. Adelabu",
    url: "https://youtu.be/y1jnL2a1WoY",
    type: "interview",
  },
  {
    name: "Dr. Ann Ogbenne",
    url: "https://youtu.be/E9UwJdKs2Es",
    type: "interview",
  },
  {
    name: "Nurse Bamgboye",
    url: "https://youtu.be/QD2VfllaxO8",
    type: "interview",
  },
  {
    name: "Pharm Vivian",
    url: "https://youtu.be/Wm7jN6CiKGs",
    type: "interview",
  },
];

const extraMedia = [
  { name: "Dr. Annette", url: "https://youtu.be/CRCR7plW_sw", type: "extra" },
  { name: "Olin Gary", url: "https://youtu.be/F6JK1zbozrQ", type: "extra" },
  {
    name: "Carina Wilkerson",
    url: "https://youtu.be/PI3rIFAMXlU",
    type: "extra",
  },
  {
    name: "Eugenia Trigoso",
    url: "https://youtu.be/rzzJpY6IQwY",
    type: "extra",
  },
];

const partners = [
  {
    name: "Prof. Wasiu Adeyemo (LUTH)",
    url: "https://youtu.be/M82F5fUYTys",
    type: "partner",
  },
  {
    name: "Chief Afolabi (Amni)",
    url: "https://youtu.be/jGiwKQhPyh0",
    type: "partner",
  },
  {
    name: "Edith Lawson (NNPC)",
    url: "https://youtu.be/Z03HU3dOwhE",
    type: "partner",
  },
  {
    name: "NNPC Official Video",
    url: "https://youtu.be/EeTp8_iSf5k",
    type: "partner",
  },
];

const ALL_MEDIA = [...interviews, ...extraMedia, ...partners];

// -------- HELPERS --------

// thumbnail helpers
const getYouTubeId = (url) => {
  if (url.includes("youtu.be/")) return url.split("youtu.be/")[1].split("?")[0];
  if (url.includes("v=")) return url.split("v=")[1].split("&")[0];
  return null;
};

const getYouTubeThumb = (url) => {
  const id = getYouTubeId(url);
  return id
    ? `https://img.youtube.com/vi/${id}/hqdefault.jpg`
    : "/assets/bmt/news_logo.png";
};

const getDriveId = (url) => {
  const match = url.match(/\/d\/(.*?)\//);
  return match ? match[1] : null;
};

const getDriveThumb = (url) => {
  const id = getDriveId(url);
  return id
    ? `https://drive.google.com/thumbnail?id=${id}`
    : "/assets/bmt/news_logo.png";
};

const getThumb = (item) => {
  if (item.url.includes("youtu")) return getYouTubeThumb(item.url);
  if (item.url.includes("drive.google.com")) return getDriveThumb(item.url);
  return "/assets/bmt/news_logo.png";
};

// embed URL for lightbox
const getEmbedUrl = (item) => {
  if (item.url.includes("youtu")) {
    const id = getYouTubeId(item.url);
    return id ? `https://www.youtube.com/embed/${id}?rel=0` : item.url;
  }
  if (item.url.includes("drive.google.com")) {
    const id = getDriveId(item.url);
    return id ? `https://drive.google.com/file/d/${id}/preview` : item.url;
  }
  return item.url;
};

// -------- SHARED LIGHTBOX HOOK-LIKE LOGIC --------

const useLightbox = () => {
  const [lightbox, setLightbox] = useState({
    isOpen: false,
    items: [],
    index: 0,
  });

  const openLightbox = (items, index) => {
    setLightbox({ isOpen: true, items, index });
  };

  const closeLightbox = () => {
    setLightbox((prev) => ({ ...prev, isOpen: false }));
  };

  const next = () => {
    setLightbox((prev) => ({
      ...prev,
      index: prev.items.length ? (prev.index + 1) % prev.items.length : 0,
    }));
  };

  const prev = () => {
    setLightbox((prev) => ({
      ...prev,
      index: prev.items.length
        ? (prev.index - 1 + prev.items.length) % prev.items.length
        : 0,
    }));
  };

  // keyboard support
  useEffect(() => {
    if (!lightbox.isOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightbox.isOpen]);

  return { lightbox, openLightbox, closeLightbox, next, prev };
};

// Shared Lightbox component
const MediaLightbox = ({ lightbox, close, next, prev }) => {
  if (!lightbox.isOpen || !lightbox.items.length) return null;

  const item = lightbox.items[lightbox.index];
  const embedUrl = getEmbedUrl(item);

  return (
    <div className="fixed inset-0 z-[999] bg-black/90 backdrop-blur-md flex items-center justify-center p-4">
      <div className="relative w-full max-w-5xl">
        {/* Close */}
        <button
          onClick={close}
          className="absolute -top-12 right-0 bg-red-600 text-white px-4 py-2 rounded-full shadow-lg hover:bg-red-700 transition"
        >
          Close
        </button>

        {/* Title */}
        <div className="absolute -top-12 left-0 text-white text-sm md:text-base font-semibold opacity-80">
          {item?.name}
        </div>

        {/* Prev / Next */}
        {lightbox.items.length > 1 && (
          <>
            <button
              onClick={prev}
              className="hidden md:flex absolute left-[-3rem] top-1/2 -translate-y-1/2 text-white bg-black/40 hover:bg-black/70 rounded-full w-10 h-10 items-center justify-center"
            >
              ‹
            </button>
            <button
              onClick={next}
              className="hidden md:flex absolute right-[-3rem] top-1/2 -translate-y-1/2 text-white bg-black/40 hover:bg-black/70 rounded-full w-10 h-10 items-center justify-center"
            >
              ›
            </button>
          </>
        )}

        <iframe
          src={embedUrl}
          className="w-full aspect-video rounded-2xl shadow-2xl"
          allowFullScreen
          title={item?.name}
        ></iframe>
      </div>
    </div>
  );
};

// shared premium card renderer used by all layouts
const MediaCard = ({ item, onClick, compact = false }) => (
  <div
    onClick={onClick}
    className={`group cursor-pointer relative block rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all bg-black ${
      compact ? "h-56" : "h-64"
    }`}
  >
    <img
      src={getThumb(item)}
      alt={item.name}
      loading="lazy"
      className="w-full h-full object-cover transform group-hover:scale-105 transition-all duration-500 opacity-90"
    />

    <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/30 to-black/80 group-hover:via-black/50 transition-all" />

    <div className="absolute inset-0 flex items-center justify-center">
      <div className="w-14 h-14 md:w-16 md:h-16 bg-white/90 group-hover:bg-white rounded-full flex items-center justify-center shadow-xl group-hover:scale-125 transition transform">
        <div className="w-0 h-0 border-t-[9px] border-b-[9px] border-l-[15px] border-transparent border-l-red-600 ml-1" />
      </div>
    </div>

    <div className="absolute bottom-0 left-0 right-0 bg-black/60 px-3 py-2 text-center">
      <p className="text-white text-[13px] md:text-[14px] font-semibold tracking-wide">
        {item.name}
      </p>
    </div>
  </div>
);

// export const Gallery = () => {
//   const { lightbox, openLightbox, closeLightbox, next, prev } = useLightbox();
//   const [filter, setFilter] = useState("all");
//   const [search, setSearch] = useState("");

//   const categories = [
//     { key: "all", label: "All Media" },
//     { key: "interview", label: "Expert Interviews" },
//     { key: "extra", label: "More Voices" },
//     { key: "partner", label: "Partners" },
//   ];

//   let filtered = ALL_MEDIA;

//   if (filter !== "all") {
//     filtered = filtered.filter((m) => m.type === filter);
//   }

//   if (search.trim()) {
//     const s = search.toLowerCase();
//     filtered = filtered.filter((m) => m.name.toLowerCase().includes(s));
//   }

//   return (
//     <>
//       <MediaLightbox
//         lightbox={lightbox}
//         close={closeLightbox}
//         next={next}
//         prev={prev}
//       />

//       <div className="px-[25px] sm:px-16 py-20 space-y-12">
//         {/* Header */}
//         <div className="text-center max-w-3xl mx-auto">
//           <h1 className="text-4xl lg:text-5xl font-extrabold text-primary_red tracking-tight">
//             Media Gallery
//           </h1>
//           <p className="mt-3 text-gray-700 text-lg">
//             Expert voices, powerful stories, and partners speaking on Bone
//             Marrow Transplantation and Sickle Cell care.
//           </p>
//         </div>

//         {/* Filters + Search */}
//         <div className="flex flex-col md:flex-row items-center justify-between gap-4">
//           <div className="flex flex-wrap gap-3">
//             {categories.map((cat) => (
//               <button
//                 key={cat.key}
//                 onClick={() => setFilter(cat.key)}
//                 className={`px-4 py-2 rounded-full text-sm font-semibold border transition-all ${
//                   filter === cat.key
//                     ? "bg-primary_red text-white border-primary_red shadow-md"
//                     : "bg-white text-gray-700 border-gray-200 hover:border-primary_red/60"
//                 }`}
//               >
//                 {cat.label}
//               </button>
//             ))}
//           </div>

//           <div className="w-full md:w-72">
//             <input
//               type="text"
//               placeholder="Search speakers..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               className="w-full px-4 py-2 rounded-full border border-gray-200 focus:outline-none focus:border-primary_red/70 shadow-sm text-sm"
//             />
//           </div>
//         </div>

//         {/* Masonry-like layout */}
//         <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6 mt-6">
//           {filtered.map((item, index) => (
//             <div key={item.name} className="break-inside-avoid">
//               <MediaCard
//                 item={item}
//                 onClick={() => openLightbox(filtered, index)}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export const Gallery = () => {
//   const { lightbox, openLightbox, closeLightbox, next, prev } = useLightbox();

//   const featured = interviews[0];

//   const rows = [
//     { title: "Expert Interviews", items: interviews },
//     { title: "More Voices & Stories", items: extraMedia },
//     { title: "Our Partners Speak", items: partners },
//   ];

//   return (
//     <>
//       <MediaLightbox
//         lightbox={lightbox}
//         close={closeLightbox}
//         next={next}
//         prev={prev}
//       />

//       <div className="px-[25px] sm:px-16 py-16 space-y-16 min-h-screen px-[25px] sm:px-16 py-20
// bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,0.08),transparent_60%)]">
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(255,255,255,0.08),transparent_70%)] pointer-events-none"></div>

//         {/* Hero */}
//         <section className="relative w-full rounded-3xl overflow-hidden shadow-2xl bg-black">
//           <img
//             src={getThumb(featured)}
//             alt={featured.name}
//             className="w-full h-[260px] md:h-[360px] lg:h-[420px] object-cover opacity-80"
//           />
//           <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent" />

//           <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10 lg:px-16 text-white max-w-xl">
//             <p className="text-sm uppercase tracking-[0.2em] text-primary_red mb-3">
//               Featured Interview
//             </p>
//             <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
//               {featured.name}
//             </h1>
//             <p className="mt-3 text-sm md:text-base text-gray-200">
//               Hear directly from leading experts and partners on life-saving BMT
//               interventions and Sickle Cell care.
//             </p>

//             <div className="mt-6">
//               <button
//                 onClick={() => openLightbox([featured, ...ALL_MEDIA], 0)}
//                 className="inline-flex items-center gap-2 bg-primary_red text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl hover:bg-primary_red/90 transition"
//               >
//                 <span className="w-3 h-3 rounded-full bg-white" />
//                 <span className="font-semibold text-sm md:text-base">
//                   Watch Now
//                 </span>
//               </button>
//             </div>
//           </div>
//         </section>

//         {/* Rails */}
//         {rows.map((row) => (
//           <section key={row.title} className="space-y-4">
//             <div className="flex items-center gap-3">
//               <h2 className="text-2xl font-bold text-gray-900">{row.title}</h2>
//               <div className="h-[2px] w-16 bg-primary_red" />
//             </div>

//             <div className="overflow-x-auto pb-2">
//               <div className="flex gap-5 min-w-full">
//                 {row.items.map((item, index) => (
//                   <div className="w-72 flex-shrink-0" key={item.name}>
//                     <MediaCard
//                       item={item}
//                       onClick={() => openLightbox(row.items, index)}
//                       compact
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section>
//         ))}
//       </div>
//     </>
//   );
// };

// export const Gallery = () => {
//   const { lightbox, openLightbox, closeLightbox, next, prev } = useLightbox();

//   const featured = interviews[0];

//   const rows = [
//     { title: "Expert Interviews", items: interviews },
//     { title: "More Voices & Stories", items: extraMedia },
//     { title: "Our Partners Speak", items: partners },
//   ];

//   return (
//     <>
//       <MediaLightbox
//         lightbox={lightbox}
//         close={closeLightbox}
//         next={next}
//         prev={prev}
//       />

//       <div className="px-[25px] sm:px-16 py-16 space-y-16">
//         {/* Hero */}
//         <section className="relative w-full rounded-3xl overflow-hidden shadow-2xl bg-black">
//           <img
//             src={getThumb(featured)}
//             alt={featured.name}
//             className="w-full h-[260px] md:h-[360px] lg:h-[420px] object-cover opacity-80"
//           />
//           <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent" />

//           <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10 lg:px-16 text-white max-w-xl">
//             <p className="text-sm uppercase tracking-[0.2em] text-primary_red mb-3">
//               Featured Interview
//             </p>
//             <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
//               {featured.name}
//             </h1>
//             <p className="mt-3 text-sm md:text-base text-gray-200">
//               Hear directly from leading experts and partners on life-saving BMT
//               interventions and Sickle Cell care.
//             </p>

//             <div className="mt-6">
//               <button
//                 onClick={() => openLightbox([featured, ...ALL_MEDIA], 0)}
//                 className="inline-flex items-center gap-2 bg-primary_red text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl hover:bg-primary_red/90 transition"
//               >
//                 <span className="w-3 h-3 rounded-full bg-white" />
//                 <span className="font-semibold text-sm md:text-base">
//                   Watch Now
//                 </span>
//               </button>
//             </div>
//           </div>
//         </section>

//         {/* Rails */}
//         {rows.map((row) => (
//           <section key={row.title} className="space-y-4">
//             <div className="flex items-center gap-3">
//               <h2 className="text-2xl font-bold text-gray-900">{row.title}</h2>
//               <div className="h-[2px] w-16 bg-primary_red" />
//             </div>

//             <div className="overflow-x-auto pb-2">
//               <div className="flex gap-5 min-w-full">
//                 {row.items.map((item, index) => (
//                   <div className="w-72 flex-shrink-0" key={item.name}>
//                     <MediaCard
//                       item={item}
//                       onClick={() => openLightbox(row.items, index)}
//                       compact
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section>
//         ))}
//       </div>
//     </>
//   );
// };

// export const Gallery = () => {
//   const { lightbox, openLightbox, closeLightbox, next, prev } = useLightbox();

//   const feature = interviews[0];
//   const restInterviews = interviews.slice(1);

//   return (
//     <>
//       <MediaLightbox
//         lightbox={lightbox}
//         close={closeLightbox}
//         next={next}
//         prev={prev}
//       />

//       <div
//         className="px-[25px] sm:px-16 py-20 space-y-16 max-w-6xl mx-auto min-h-screen px-[25px] sm:px-16 py-20
// bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,0.08),transparent_60%)]"
//       >
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(255,255,255,0.08),transparent_70%)] pointer-events-none"></div>
//         {/* Editorial Header */}
//         <header className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-gray-200 pb-6">
//           <div>
//             <p className="uppercase text-xs tracking-[0.3em] text-primary_red mb-2">
//               Media Feature
//             </p>
//             <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900">
//               Stories & Voices
//             </h1>
//             <p className="mt-3 text-gray-600 max-w-xl">
//               A curated collection of expert insights, heartfelt testimonies,
//               and partner reflections on BMT and Sickle Cell care.
//             </p>
//           </div>
//           <span className="text-xs text-gray-500">
//             MEDIA • INTERVIEWS • PARTNERS
//           </span>
//         </header>

//         {/* Top Feature Row */}
//         <section className="grid md:grid-cols-[2fr,1.2fr] gap-8 items-stretch">
//           {/* Big feature */}
//           <div
//             className="relative rounded-3xl overflow-hidden shadow-xl cursor-pointer group bg-black"
//             onClick={() => openLightbox([feature, ...ALL_MEDIA], 0)}
//           >
//             <img
//               src={getThumb(feature)}
//               alt={feature.name}
//               className="w-full h-[260px] md:h-[320px] object-cover group-hover:scale-105 transition transform duration-500"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/10" />
//             <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
//               <p className="text-xs uppercase text-primary_red tracking-[0.2em] mb-1">
//                 Feature Interview
//               </p>
//               <h2 className="text-2xl md:text-3xl font-bold leading-tight">
//                 {feature.name}
//               </h2>
//               <p className="text-sm text-gray-200 mt-2">
//                 In-depth conversation on BMT, patient care, and the future of
//                 Sickle Cell treatment.
//               </p>
//             </div>
//           </div>

//           {/* Side stacked smaller */}
//           <div className="space-y-4">
//             {restInterviews.slice(0, 3).map((item, index) => (
//               <div
//                 key={item.name}
//                 className="flex gap-4 items-center cursor-pointer"
//                 onClick={() => openLightbox(interviews, index + 1)}
//               >
//                 <div className="w-32 h-24 rounded-xl overflow-hidden shadow-md bg-black">
//                   <img
//                     src={getThumb(item)}
//                     alt={item.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div>
//                   <p className="text-xs uppercase text-gray-500">Interview</p>
//                   <h3 className="font-semibold text-gray-900 text-sm md:text-base">
//                     {item.name}
//                   </h3>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* More voices + Partners in 2-column editorial layout */}
//         <section className="grid md:grid-cols-2 gap-12">
//           <div>
//             <h2 className="text-2xl font-bold mb-4">More Voices & Stories</h2>
//             <div className="space-y-4">
//               {extraMedia.map((item, index) => (
//                 <div
//                   key={item.name}
//                   className="flex gap-4 items-center cursor-pointer"
//                   onClick={() => openLightbox(extraMedia, index)}
//                 >
//                   <div className="w-28 h-20 rounded-xl overflow-hidden shadow bg-black">
//                     <img
//                       src={getThumb(item)}
//                       alt={item.name}
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div>
//                     <p className="text-xs uppercase text-gray-500">Interview</p>
//                     <h3 className="font-semibold text-gray-900 text-sm md:text-base">
//                       {item.name}
//                     </h3>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div>
//             <h2 className="text-2xl font-bold mb-4">Our Partners Speak</h2>
//             <div className="space-y-4">
//               {partners.map((item, index) => (
//                 <div
//                   key={item.name}
//                   className="flex gap-4 items-center cursor-pointer"
//                   onClick={() => openLightbox(partners, index)}
//                 >
//                   <div className="w-28 h-20 rounded-xl overflow-hidden shadow bg-black">
//                     <img
//                       src={getThumb(item)}
//                       alt={item.name}
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div>
//                     <p className="text-xs uppercase text-gray-500">
//                       Partner Feature
//                     </p>
//                     <h3 className="font-semibold text-gray-900 text-sm md:text-base">
//                       {item.name}
//                     </h3>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

export const Gallery = () => {
  const { lightbox, openLightbox, closeLightbox, next, prev } = useLightbox();

  const feature = interviews[0];
  const restInterviews = interviews.slice(1);

  return (
    <>
      {/* LIGHTBOX */}
      <MediaLightbox
        lightbox={lightbox}
        close={closeLightbox}
        next={next}
        prev={prev}
      />

      {/* PAGE WRAPPER WITH BACKGROUND */}
      <div className="relative min-h-screen mt-14">
        {/* BACKGROUND LAYERS */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,0.08),transparent_60%)] pointer-events-none"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(255,255,255,0.08),transparent_70%)] pointer-events-none"></div>

        {/* CONTENT */}
        <div className="relative px-[25px] sm:px-16 py-20 space-y-16 max-w-7xl mx-auto">
          {/* HEADER */}
          <header className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-gray-200 pb-6">
            <div>
              <p className="uppercase text-xs tracking-[0.3em] text-primary_red mb-2">
                Media Feature
              </p>
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900">
                Stories & Voices
              </h1>
              <p className="mt-3 text-gray-600 max-w-xl">
                A curated collection of expert insights, heartfelt testimonies,
                and partner reflections on Bone Marrow Transplantation and
                Sickle Cell care.
              </p>
            </div>
            <span className="text-xs text-gray-500">
              MEDIA • INTERVIEWS • PARTNERS
            </span>
          </header>

          {/* FEATURE + SIDEBAR */}
          <section className="grid md:grid-cols-[2fr,1.2fr] gap-8 items-start">
            {/* FEATURED VIDEO */}
            <div
              className="relative rounded-3xl overflow-hidden shadow-xl cursor-pointer group bg-black"
              onClick={() => openLightbox(interviews, 0)}
            >
              <img
                src={getThumb(feature)}
                alt={feature.name}
                className="w-full h-[260px] md:h-[340px] object-cover group-hover:scale-105 transition transform duration-500"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <p className="text-xs uppercase text-primary_red tracking-[0.2em] mb-1">
                  Feature Interview
                </p>
                <h2 className="text-2xl md:text-3xl font-bold leading-tight">
                  {feature.name}
                </h2>
                <p className="text-sm text-gray-200 mt-2">
                  In-depth expert insights shaping the future of BMT in Nigeria.
                </p>
              </div>
            </div>

            {/* FULL SIDEBAR LIST (ALL INTERVIEWS) */}
            <div className="relative">
              {/* Top Fade */}
              <div className="absolute top-0 left-0 right-0 h-6 bg-gradient-to-b from-white via-white/80 to-transparent pointer-events-none"></div>

              {/* Scrollable List */}
              <div
                className="space-y-4 overflow-y-auto pr-2"
                style={{ maxHeight: "340px" }}
              >
                {restInterviews.map((item, index) => (
                  <div
                    key={item.name}
                    className="flex gap-4 items-center cursor-pointer group"
                    onClick={() => openLightbox(interviews, index + 1)}
                  >
                    <div className="w-32 h-24 rounded-xl overflow-hidden shadow bg-black group-hover:shadow-xl transition">
                      <img
                        src={getThumb(item)}
                        alt={item.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition"
                      />
                    </div>

                    <div>
                      <p className="text-xs uppercase text-gray-500">
                        Interview
                      </p>
                      <h3 className="font-semibold text-gray-900 text-sm md:text-base group-hover:text-primary_red transition">
                        {item.name}
                      </h3>
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom Fade */}
              <div className="absolute bottom-0 left-0 right-0 h-6 bg-gradient-to-t from-white via-white/80 to-transparent pointer-events-none"></div>
            </div>
          </section>

          {/* SECTION DIVIDER */}
          <div className="h-[1px] bg-gray-200 my-10"></div>

          {/* MORE VOICES */}
          <section>
            <h2 className="text-3xl font-bold mb-6">More Voices & Stories</h2>
            <div className="grid md:grid-cols-2 gap-8">
              {extraMedia.map((item, index) => (
                <div
                  key={item.name}
                  className="flex gap-4 items-center cursor-pointer group"
                  onClick={() => openLightbox(extraMedia, index)}
                >
                  <div className="w-40 h-28 rounded-xl overflow-hidden shadow bg-black">
                    <img
                      src={getThumb(item)}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition"
                    />
                  </div>

                  <div>
                    <p className="text-xs uppercase text-gray-500">Story</p>
                    <h3 className="font-semibold text-gray-900 text-sm md:text-lg group-hover:text-primary_red transition">
                      {item.name}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* SECTION DIVIDER */}
          <div className="h-[1px] bg-gray-200 my-10"></div>

          {/* PARTNERS */}
          <section>
            <h2 className="text-3xl font-bold mb-6">Our Partners Speak</h2>

            <div className="grid md:grid-cols-2 gap-8">
              {partners.map((item, index) => (
                <div
                  key={item.name}
                  className="flex gap-4 items-center cursor-pointer group"
                  onClick={() => openLightbox(partners, index)}
                >
                  <div className="w-40 h-28 rounded-xl overflow-hidden shadow bg-black">
                    <img
                      src={getThumb(item)}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition"
                    />
                  </div>

                  <div>
                    <p className="text-xs uppercase text-gray-500">Partner</p>
                    <h3 className="font-semibold text-gray-900 text-sm md:text-lg group-hover:text-primary_red transition">
                      {item.name}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

// export const Gallery = () => {
//   const { lightbox, openLightbox, closeLightbox, next, prev } = useLightbox();

//   return (
//     <>
//       <MediaLightbox
//         lightbox={lightbox}
//         close={closeLightbox}
//         next={next}
//         prev={prev}
//       />

//       <div className="px-[25px] sm:px-16 py-20 max-w-6xl mx-auto space-y-12">
//         <header className="text-center space-y-4">
//           <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 tracking-tight">
//             Media
//           </h1>
//           <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
//             A curated selection of interviews and partner stories about Bone
//             Marrow Transplantation, impact, and hope.
//           </p>
//         </header>

//         <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
//           {ALL_MEDIA.map((item, index) => (
//             <div key={item.name} className="flex flex-col gap-3">
//               <div
//                 className="rounded-3xl overflow-hidden bg-gray-100 cursor-pointer hover:shadow-xl transition-shadow"
//                 onClick={() => openLightbox(ALL_MEDIA, index)}
//               >
//                 <img
//                   src={getThumb(item)}
//                   alt={item.name}
//                   className="w-full h-56 object-cover"
//                 />
//               </div>
//               <div className="space-y-1">
//                 <p className="text-xs uppercase tracking-[0.2em] text-gray-400">
//                   {item.type === "partner"
//                     ? "Partner"
//                     : item.type === "extra"
//                     ? "Story"
//                     : "Interview"}
//                 </p>
//                 <h3 className="text-sm md:text-base font-semibold text-gray-900">
//                   {item.name}
//                 </h3>
//               </div>
//             </div>
//           ))}
//         </section>
//       </div>
//     </>
//   );
// };

export default Gallery;
